import { Box, Container } from '@codeparva/ui-components-library';
import React from 'react';
import { weakKey } from '../../../utilities/weakKey';
import { UserFlowTypes } from '../UserFlowTypes';
import { accountSectionConfig } from './accountConfig';
import {
  AccountDetails,
  PaymentSection,
  ViewAccount,
} from '../helpers/accountSectionHelper';

export const AccountSelection = ({
  ledgerRes,
  unitRes,
  locationName,
  reservationData,
}: UserFlowTypes.TAccountSelection) => {
  const { data, relational_data } = unitRes;
  let accountDetails: UserFlowTypes.TAccountDetails[] = [];
  let unitList: UserFlowTypes.TUnitList[] = [];

  const {
    data: {
      data: reservationList = [],
      relational_data: {
        unit_type: reservedUnitTypeData = [],
        unit: reservedUnitData = [],
      } = {},
    } = {},
  } = reservationData || {};

  const mapReservationsByLedgerId = (
    reservationList: UserFlowTypes.TReservation[]
  ) => {
    const ledgerIdMap: { [key: string]: UserFlowTypes.TReservation[] } = {};
    reservationList.forEach((reservation: UserFlowTypes.TReservation) => {
      const { ledger, unit_type_id, unit_id } = reservation;
      const { description } =
        reservedUnitTypeData.find(
          (type: { id: string }) => type.id === unit_type_id
        )?.value || {};
      const unit_label =
        unit_id &&
        reservedUnitData.find((unit: { id: string }) => unit.id === unit_id)
          ?.label;

      if (!ledgerIdMap[ledger.id]) {
        ledgerIdMap[ledger.id] = [];
      }

      ledgerIdMap[ledger.id].push({
        ...reservation,
        unit_type_description: description,
        unit_label,
      });
    });
    return ledgerIdMap;
  };

  const mappedReservationData = mapReservationsByLedgerId(reservationList);

  const setLedgerResponse = (
    ledgerRes: UserFlowTypes.TAccountSelectionLedgerRes[]
  ) => {
    for (let index = 0; index < ledgerRes.length; index++) {
      let currLedgerId: string = ledgerRes[index].id;
      let currUnitData: UserFlowTypes.TUnitList[] = [];

      currUnitData = unitList.filter(curUnit =>
        curUnit.ledgerId == currLedgerId ? curUnit : undefined
      );

      accountDetails[index] = {
        id: currLedgerId,
        label: ledgerRes[index].label,
        balance: ledgerRes[index].balance,
        unitDetails: currUnitData,
        reservationDetails: mappedReservationData[currLedgerId],
      };
    }
  };
  const setUnitResponse = (unitRes: UserFlowTypes.TDataEntity[]) => {
    for (let index = 0; index < unitRes.length; index++) {
      let currUnitId: string = unitRes[index].unit_type.id;
      let currUnitData = setUnitData(currUnitId);
      unitList[index] = {
        ledgerId: unitRes[index].ledger.id,
        label: unitRes[index].label,
        unit_type: currUnitId,

        unitDetails: {
          unitDescription: currUnitData[0].description,
          unitCategory: currUnitData[0].category,
        },
      };
    }
  };

  const setUnitData = (unitId: string) => {
    let currUnitData: UserFlowTypes.TCurrentUnitData[] = [];

    for (let index = 0; index < relational_data.unit_type.length; index++) {
      if (relational_data.unit_type[index].id === unitId) {
        currUnitData[0] = {
          category: relational_data.unit_type[index].value.category,
          description: relational_data.unit_type[index].value.description,
        };
      }
    }
    return currUnitData;
  };
  setUnitResponse(data);
  setLedgerResponse(ledgerRes);

  return (
    <Container className="contentAccountParentContainer mt-0">
      <div className="contentAccountContainer">
        <div className="greetingsSection">
          <h3 className="greetingMessage titleColor">
            {accountSectionConfig.greet}{' '}
            <span className="has-text-weight-bold">
              {locationName} Account Access!
            </span>
          </h3>
        </div>
        <div className="accountMainBox">
          <div>
            <h4 className="accountPadding titleColor">
              {accountSectionConfig.accountTitle}
            </h4>
          </div>
          {accountDetails.map((account, index) => {
            return (
              <Box
                key={weakKey(account)}
                className="boxAccountSection titleColor"
              >
                <AccountDetails account={account} />
                <div className="dividerAccount"></div>
                <PaymentSection account={account} />
                <div className="dividerButton"></div>
                <ViewAccount account={account} index={index} />
              </Box>
            );
          })}
        </div>
      </div>
    </Container>
  );
};
